export const ELLIPSIS_ITEM = '…';
